import React from 'react'
import Modal from 'react-modal'

import AddItemToCollectionContainer from './collection/addItemToCollectionContainer'
import AddItemToCartContainer from './cart/addItemToCartContainer'
import SignInContainer from './user/signInContainer'

export default ({ isModalOpen, closeModal, openModalType, openModalData }) => {
  const renderModalContent = () => {
    switch (openModalType) {
      case 'addItemToCollection':
        return (
          <AddItemToCollectionContainer
            openModalData={openModalData}
            closeModal={closeModal}
          />
        )

      case 'addItemToCart':
        return <AddItemToCartContainer openModalData={openModalData} />

      case 'signIn':
        return (
          <SignInContainer
            closeModal={closeModal}
            openModalData={openModalData}
          />
        )

      default:
        return null
    }
  }

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={closeModal}
      contentLabel="Modal"
      className="ReactModal__Content"
      overlayClassName="ReactModal__Overlay"
    >
      {renderModalContent()}
    </Modal>
  )
}



// WEBPACK FOOTER //
// ./client/components/modals/index.js